$(document).ready(function () {
  document.addEventListener('rebuy:cart.change', (event) => { 
    $(".header__icons").load(" .header__icons"); 
  });

  $(".s-qstn .q-title, .s-qstn .symbol").click(function (e) { 
    e.preventDefault();
    $(this).parents(".s-qstn").find(".ans").slideToggle();
    $(this).parents(".s-qstn").find(".plus").toggle();
    $(this).parents(".s-qstn").find(".minus").toggle();
    $(this).toggleClass("active");
  });
  $(".hover-search").click(function(e){
    e.preventDefault();
    if($(this).hasClass("hover-content-show")){
      $(this).removeClass("hover-content-show");
      $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("opacity", "0");
      $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("visibility", "hidden");
    }else{
      $(this).addClass("hover-content-show");
      $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("opacity", "1");
      $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("visibility", "initial");
    }
  });
  $(".hover-search").hover(function (e) {
    // over
    e.preventDefault();
    $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("opacity", "1");
    $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("visibility", "initial");
    
  }, function (e) {
    // out
    e.preventDefault();
    $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("opacity", "0");
    $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("visibility", "hidden");
  });

  let articles = $('.PRS .product-review');
  let groupNum = 0;
  let totalNum = 0;
  let currentGroupNum = 0;
  let totalBlocks = 0;
  $.each(articles, function(index, value) {
    $(this).addClass("group" + groupNum);
    totalBlocks = parseInt($(this).attr("last-block-number"));
    if ((index + 1) % 5 === 0) {
      groupNum++;
    }
  });
  $('.PRS .loadmore-reviews').on('click', function(e){
    e.preventDefault();
    $(".group" + currentGroupNum).show();
    totalNum += 5;
    console.log(totalBlocks);
    console.log(totalNum);
    if(totalBlocks == totalNum){
      $(this).hide();
    }
    currentGroupNum++;
  });
  setTimeout(() => {
    $('.PRS .loadmore-reviews').click();
  }, 1000);

  $(".PRS .product-review .review-desc").each(function(){
    let maxLength = 435;  
    let myStr = $(this).text();
    if($.trim(myStr).length > maxLength){
      let newStr = myStr.substring(0, maxLength);
      let removedStr = myStr.substring(maxLength, myStr.length);
      $(this).empty().html(newStr);
      $(this).append('<span class="read-more">... <span class="read-more-text">read more</span></span>');
      $(this).append('<span class="more-text">'+removedStr+'</span>');
    }
  });
  $(".PRS .product-review .review-desc .read-more").click(function(){
    $(this).siblings(".more-text").contents().unwrap();
    $(this).remove();
  });
  // faqs
  $(".FAQS .faq .s-faq .qstn").click(function() {
      $(this).siblings(".ans").slideToggle();
      $(this).find(".minus").toggle();
      $(this).find(".plus").toggle();
  });

  // all product quick add popup qty selector
  let qtyNum = 1;
  $(".quick-add-popup .qty-selector .qty-box").text(qtyNum);
  $(".quick-add-popup .qty-selector .minus-icon").click(function (e) { 
    e.preventDefault();
    if(qtyNum > 1){
      qtyNum--;
      $(".quick-add-popup .qty-selector .qty-box").text(qtyNum);
    }
  });
  $(".quick-add-popup .qty-selector .plus-icon").click(function (e) { 
    e.preventDefault();
    qtyNum++;
    $(".quick-add-popup .qty-selector .qty-box").text(qtyNum);
  });

  // add to cart - collection page product quick add popup
  $(".quick-add-popup .variant-options .option-variant-input").first().click();
  $(".quick-add-popup .add-to-cart-btn-in-modal .atc-btn").click(function (e) { 
    e.preventDefault();
    let activeVariantId = null;
    let qtyValue = null;
    let selling_plan_id = $(this).attr("selling-plan-id");
    $(this).parents(".qty-selector-with-atc").siblings(".variant-options").children(".varint-opt-box").each(function(){
      if($(this).children(".option-variant-input").is(":checked")){
        activeVariantId = $(this).children(".option-variant-input").val();
        console.log(activeVariantId);
      }
    });
    // $(this).attr("variant-id");
    qtyValue = parseInt($(this).parents(".add-to-cart-btn-in-modal").siblings(".qty-selector").find(".qty-box").text());
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: activeVariantId,
        quantity: qtyValue,
        selling_plan: selling_plan_id
      },
      dataType: "json",
      success: function(data) {
        console.log(data.id);
        
      },
      error: function(data){
        console.log(data);
      }
    });
  });

  // header menu
  $(document).mouseup(function(e){
    var container = $("#menu-drawer");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").removeClass("mobile-submene-opened");
      $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").addClass("up-arrow");
      $("#menu-drawer .menu-drawer__submenu").slideUp();
    }
  });
  $(".close-icon .icon.icon-close").click(function(){
    $(".header__icon .icon-close").click();
    $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").removeClass("mobile-submene-opened");
    $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").addClass("up-arrow");
    $("#menu-drawer .menu-drawer__submenu").slideUp();
  });
  $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").click(function(event){
    event.preventDefault();
    $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").attr('open', '');
    $(this).toggleClass("up-arrow");
    $(this).toggleClass("mobile-submene-opened");
    $("#menu-drawer .menu-drawer__submenu").slideToggle();
  });

  // cart items
  function setQuantityToOne() {
    // Fetch the current cart
    $.ajax({
      type: 'GET',
      url: '/cart.js', // Shopify's cart API endpoint
      dataType: 'json',
      success: function(cart) {
        // Modify the quantity for each item
        $.each(cart.items, function(index, item) {
          // Update the quantity to 1
          console.log(item);
          if(item.handle.includes("trial")) updateCartItemQuantity(item.key, 1);
        });
      },
      error: function(err) {
        console.error('Error fetching cart:', err);
      }
    });
    setTimeout(() => {
      $(".cart-items-to-load").load(" .cart-items-to-load");
      $(".cart-footer-to-load").load(" .cart-footer-to-load");
      $(".header__cart-count").load(" .header__cart-count");
    }, 2000);
  }

  function updateCartItemQuantity(itemKey, newQuantity) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js', // Shopify's cart update API endpoint
      data: {
        updates: {
          [itemKey]: newQuantity
        }
      },
      dataType: 'json',
      success: function(updatedCart) {
        console.log('Item updated successfully:', updatedCart);
      },
      error: function(err) {
        console.error('Error updating item:', err);
      }
    });
  }
  setQuantityToOne();

  // hover on product media
  $(".product-template-wrapper .product__media-wrapper .product__media-list .product__media-item").hover(function () {
      // over
      $(this).find(".plus-icon-on-hover").css('display', 'flex');
    }, function () {
      // out
      $(this).find(".plus-icon-on-hover").css('display', 'none');
    }
  );

  // product page accordion
  var isOpened = null;
  $(".product__accordion-wrapper").each(function(){
    isOpened = $(this).find("details").attr('opened');
    if(isOpened !== undefined){
      $(this).find("details").attr('opened',  '');
      $(this).find(".accordion__content").slideDown();
    }else{
      $(this).find("details").removeAttr('opened');
      $(this).find(".accordion__content").slideUp();
    }
  })
  $(".product__accordion-wrapper .product__accordion.accordion summary").click(function(e){
    e.preventDefault();
    $(".product__accordion-wrapper .product__accordion.accordion details").not($(this).parents("details")).removeAttr('opened');
    $(".product__accordion-wrapper .product__accordion.accordion .accordion__content").not($(this).siblings(".accordion__content")).slideUp();
    isOpened = $(this).parents("details").attr('opened');
    if(isOpened === undefined){
      $(this).parents("details").attr('opened',  '');
      $(this).siblings(".accordion__content").slideDown();
    }else{
      $(this).parents("details").removeAttr('opened');
      $(this).siblings(".accordion__content").slideUp();
    }
  });

  // BFS learn more
  $(".FBS .learn-more-btn").click(function (e) { 
    e.preventDefault();
    $(this).parents(".learn-more-btns").siblings(".learn-more-desc").slideToggle();
  });


  // add bundles to cart - test script
  $(".add-bundle-to-cart").click(function (e) { 
    e.preventDefault();
    let bundleID = $(this).attr("bundle-id");
    let sellingPlan = $(this).attr("selling-plan");
    data = {
      "id": bundleID,
      "quantity": 1,
      "selling_plan": sellingPlan,
      "properties": {
        "Contents": "2x Strong (5)"
      }
    }
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function(data) {
          console.log(data.id);
          
      },
      error: function(data) {
          console.error("Error:", data.statusText);
      }
    });
  });
  $('#BT5 a.section-scroll-btn[href^="#"]').on('click', function(event) {
    var target = $(this.getAttribute('href'));
    if(target.length) {
      event.preventDefault();
      $('html, body').stop().animate({
        scrollTop: target.offset().top
      }, 1000);
    }
  });
  
  // custom AJAX call
  $("#BT5 .enable_atc_custom_ajax").click(function (e) { 
    e.preventDefault();
    let selling_plan_id = $(this).attr('selling-plan-id');
    let productId = $(this).attr('product-id');
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: productId,
          quantity: 1,
          selling_plan: selling_plan_id
        },
        dataType: "json",
        success: function(data) {
          console.log(data.id);
        },
        error: function(data){
          console.log(data);
        }
      });
  });

  console.log("PLay");
  $(".NVB .background-video-desktop").attr('autoplay', 'true');
});
